import { Accordion as PRAccordion } from "primereact/accordion";
import styled from "styled-components";
import {
  compose,
  space,
  layout,
  flexbox,
  position,
  gridGap,
  gridColumnGap,
  grid,
} from "styled-system";

import Icon from "@components/Icon";
import RichText from "@components/RichText";

const StyledRichText = styled(RichText)`
  font-weight: var(--regular-weight);

  p {
    font-size: var(--fs-text-small) !important;
    line-height: var(--lh-text-secondary) !important;
    font-weight: var(--regular-weight) !important;
    color: var(--grey-dark) !important;
  }

  br:last-child {
    display: none;
  }

  -webkit-text-size-adjust: none;
`;

const StyledAccordion = styled(PRAccordion).attrs({
  className: "deviations-accordion",
})`
  ${compose(space, flexbox, layout, position, gridGap, gridColumnGap, grid)};
`;

const StyledIcon = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin-bottom: 16px;
`;

export { StyledRichText, StyledAccordion, StyledIcon };
